var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingFiveStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9307 12.6086L13.2433 13.2926C13.4987 13.426 13.7973 13.2106 13.7487 12.9286L13.498 11.4786L14.56 10.452C14.7667 10.252 14.6527 9.90329 14.3667 9.86196L12.8993 9.64996L12.2427 8.32929C12.1147 8.07196 11.7453 8.07196 11.618 8.32929L10.9613 9.64996L9.49402 9.86196C9.20868 9.90329 9.09402 10.252 9.30068 10.452L10.3627 11.4786L10.112 12.9286C10.0633 13.2106 10.362 13.4266 10.6173 13.2926L11.93 12.6086",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 7.13799L9.31202 7.82199C9.56735 7.95532 9.86602 7.73999 9.81735 7.45799L9.56669 6.00799L10.6287 4.98132C10.8354 4.78132 10.7214 4.43265 10.4354 4.39132L8.96869 4.17999L8.31202 2.85932C8.18402 2.60199 7.81469 2.60199 7.68735 2.85932L7.03135 4.17999L5.56335 4.39199C5.27802 4.43332 5.16335 4.78199 5.37002 4.98199L6.43202 6.00865L6.18135 7.45865C6.13269 7.74065 6.43135 7.95665 6.68669 7.82265L7.99935 7.13865",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06838 12.6086L5.38104 13.2926C5.63638 13.426 5.93504 13.2106 5.88638 12.9286L5.63571 11.4786L6.69771 10.452C6.90438 10.252 6.79038 9.90329 6.50438 9.86196L5.03704 9.64996L4.38038 8.32929C4.25238 8.07196 3.88304 8.07196 3.75571 8.32929L3.09904 9.64996L1.63171 9.86196C1.34638 9.90329 1.23171 10.252 1.43838 10.452L2.50038 11.4786L2.24971 12.9286C2.20104 13.2106 2.49971 13.4266 2.75504 13.2926L4.06771 12.6086",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingFiveStar);
export default __webpack_public_path__ + "static/media/Rating, Five, Star,.02c3d18c93086f50c3e8a88448f92b78.svg";
export { ForwardRef as ReactComponent };